import React, { useState } from 'react';
import { Box, Typography, Button, styled, Link, Divider } from '@mui/material';
import { CloudArrowUp } from '@phosphor-icons/react';
import { commonStyles } from '../../../utils/styles/inputs';
import OutboundFileUploadModal from '../../modals/OutboundFileUploadModal';

// Reusable styled components
export const HeaderSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '12px 24px',
});

// Main component
const OutboundFiles: React.FC<{ agentId: string }> = ({ agentId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <HeaderSection>
        <Typography variant="h6" sx={commonStyles.typography.title}>
          Upload Files
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Uploading same structure file frequently?
          </Typography>
          <Link
            href="#"
            underline="none"
            sx={{ color: 'primary.main', fontSize: '14px' }}
          >
            Create Mapping Template
          </Link>
          <Typography variant="body2" color="text.secondary">
            to skip manual mapping
          </Typography>
        </Box>
      </HeaderSection>
      <Divider />

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 2,
            border: '1px dashed #DCE0E7',
            borderRadius: '8px',
            padding: '24px',
            maxWidth: '600px',
            width: '90%',
          }}
        >
          <CloudArrowUp size={30} />

          <Typography variant="body1" color="text.secondary">
            Please, Upload a file with phone numbers for outbound calls.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Ensure it's in a supported format (CSV/Excel)
          </Typography>
          <Button
            variant="contained"
            startIcon={<CloudArrowUp size={20} />}
            onClick={() => setIsModalOpen(true)}
            sx={{ textTransform: 'none', mt: 2 }}
          >
            Upload File
          </Button>
        </Box>
      </Box>
      <OutboundFileUploadModal
        agentId={agentId}
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </Box>
  );
};

export default OutboundFiles;
